import CreditCardIcon from "@mui/icons-material/CreditCard";
import PixIcon from "@mui/icons-material/Pix";
import BoletoIcon from "@mui/icons-material/Receipt";
import { Card, CircularProgress, Skeleton } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React from "react";

import NoDataImage from "@/assets/error/no-data-found.jpg";
import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import AlertBlock from "@/components/molecules/AlertBlock";
import { formatCurrency } from "@/helpers/currency-helpers";
import useGetTalk2PayFees from "@/hooks/requests/t2Pay/use-get-talk2pay-fees";
import { ratesMessages } from "@/messages/platforms/talk2PayConnection/ratesMessages";

import { RateCard } from "../../Talk2payHome/components/RatesTab/ratesCard";

const Rates: React.FC = () => {
  const { data: fees, isLoading, error } = useGetTalk2PayFees();

  const boletoValue = fees?.payment.bankSlip.defaultValue ?? 1.99;
  const creditOpValue = fees?.payment.creditCard.operationValue ?? 0.49;
  const creditOne = fees?.payment.creditCard.oneInstallmentPercentage ?? 2.99;
  const creditUpToSix = fees?.payment.creditCard.upToSixInstallmentsPercentage ?? 3.49;
  const creditUpToTwelve = fees?.payment.creditCard.upToTwelveInstallmentsPercentage ?? 3.99;
  const debitPerc = fees?.payment.debitCard.defaultPercentage ?? 1.89;
  const debitOp = fees?.payment.debitCard.operationValue ?? 0.35;
  const pixFixed = fees?.payment.pix.fixedFeeValue ?? 1.99;

  return (
    <Card>
      <MDBox p={3}>
        <MDTypography variant="h5">
          {isLoading ? <Skeleton width="50%" /> : (ratesMessages.ratesTitle ?? "Tarifas")}
        </MDTypography>
      </MDBox>

      <MDBox p={3} pt={0}>
        {isLoading && (
          <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="200px">
            <CircularProgress />
          </MDBox>
        )}

        {!isLoading && (
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <RateCard
                icon={<BoletoIcon fontSize="large" />}
                title={ratesMessages.ratesText3}
                primaryTextList={[
                  {
                    primaryValue: `${formatCurrency(boletoValue)}`,
                    primaryText: ratesMessages.primaryTextBankSlip,
                  },
                ]}
                secondaryText={ratesMessages.ratesText5}
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <RateCard
                icon={<CreditCardIcon fontSize="large" />}
                title={ratesMessages.ratesText6}
                primaryTextList={[
                  {
                    primaryValue: `${creditOne}% + ${formatCurrency(creditOpValue)}`,
                    primaryText: ratesMessages.primaryTextCreditOneInstallment,
                  },
                  {
                    primaryValue: `${creditUpToSix}% + ${formatCurrency(creditOpValue)}`,
                    primaryText: ratesMessages.primaryTextCreditUpToSix,
                  },
                  {
                    primaryValue: `${creditUpToTwelve}% + ${formatCurrency(creditOpValue)}`,
                    primaryText: ratesMessages.primaryTextCreditUpToTwelve,
                  },
                ]}
                secondaryText={ratesMessages.ratesText10}
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <RateCard
                icon={<CreditCardIcon fontSize="large" />}
                title={ratesMessages.ratesText11}
                primaryTextList={[
                  {
                    primaryValue: `${debitPerc}% + ${formatCurrency(debitOp)}`,
                    primaryText: ratesMessages.primaryTextDebit,
                  },
                ]}
                secondaryText={ratesMessages.ratesText13}
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <RateCard
                icon={<PixIcon fontSize="large" />}
                title={ratesMessages.ratesText14}
                primaryTextList={[
                  {
                    primaryValue: `${formatCurrency(pixFixed)}`,
                    primaryText: ratesMessages.primaryTextPixDynamic,
                  },
                ]}
                secondaryText={ratesMessages.ratesText16}
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <RateCard
                icon={<PixIcon fontSize="large" />}
                title={ratesMessages.ratesText17}
                primaryTextList={[
                  {
                    primaryValue: `${formatCurrency(pixFixed)}`,
                    primaryText: ratesMessages.primaryTextPixStatic,
                  },
                ]}
                secondaryText={ratesMessages.ratesText20}
                extraText={ratesMessages.ratesText19}
              />
            </Grid>
          </Grid>
        )}
      </MDBox>

      {error && !fees && (
        <AlertBlock
          title={"Erro ao carregar tarifas"}
          description={error.message}
          src={NoDataImage}
          alt={""}
        />
      )}
    </Card>
  );
};

export default Rates;
